export const GET_TRANSLATE = `
query AppFetchTranslate($platform: String!, $version: String) {
  appFetchTranslate(platform: $platform, version: $version) {
    success
    message
    code
    payload {
      key
      value
    }
  }
}
`

export const GET_LANGUAGE = `
query AppFetchLanguage($platform: String!) {
  appFetchLanguage(platform: $platform) {
    success
    message
    code
    payload {
      key
      name
      icon
    }
  }
}
`
